// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[6].use[2]!../../colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EntryCard_card__-F3zR {
  position: relative;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--bg);
  padding: var(--space-4) var(--space-4) var(--space-3);
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  box-shadow: var(--shadow-xs);
}

.EntryCard_card__-F3zR::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  border-radius: var(--radius-md) 0 0 var(--radius-md);
  background: var(--primary);
}

.EntryCard_card__-F3zR > * {
  position: relative; /* keep content above the accent stripe */
}

/* Header */
.EntryCard_header__WDCB9 {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.EntryCard_title__Scoh\\+ {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-primary);
}

.EntryCard_timestamp__rOTLP {
  font-size: 0.8125rem;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
}

/* Content */
.EntryCard_section__U7I7Q p {
  margin: 3px 0;
  font-size: 0.875rem;
  color: var(--text-primary);
}

/* Device info container */
.EntryCard_deviceBox__P0YWl {
  background: var(--bg-tertiary);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-sm);
  padding: var(--space-2);
}

.EntryCard_deviceLabel__5DlsK {
  margin: 0;
  font-size: 0.8125rem;
  font-weight: 600;
  color: var(--text-primary);
}

.EntryCard_deviceText__S6w4p {
  margin: 2px 0 0 0;
  font-size: 0.8125rem;
  color: var(--text-secondary);
}

/* Status tags */
.EntryCard_tagRow__Fi9dO {
  display: flex;
  gap: var(--space-2);
  margin-top: var(--space-1);
}

.EntryCard_tag__h2JL4 {
  padding: 2px 7px;
  border-radius: var(--radius-xs);
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.EntryCard_tagReviewed__nIntS {
  background: var(--surface-success);
  color: #1b5e20;
}

.EntryCard_tagWarning__oUDpo {
  background: var(--surface-error);
  color: #b71c1c;
}

/* Phones: metrics in two columns so each result card stays short. */
@media (max-width: 480px) {
  .EntryCard_card__-F3zR {
    padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);
    gap: var(--space-1);
  }

  .EntryCard_header__WDCB9 {
    gap: var(--space-2);
  }

  .EntryCard_timestamp__rOTLP {
    font-size: 0.75rem;
    text-align: right;
  }

  .EntryCard_section__U7I7Q {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    column-gap: var(--space-3);
  }

  .EntryCard_section__U7I7Q p {
    margin: 1px 0;
    font-size: 0.8125rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DashBoard/EntryCard.module.css"],"names":[],"mappings":"AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;EACrB,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU;EACV,YAAY;EACZ,oDAAoD;EACpD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB,EAAE,yCAAyC;AAC/D;;AAEA,WAAW;AACX;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,0BAA0B;AAC1B;EACE,8BAA8B;EAC9B,qCAAqC;EACrC,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE;IACE,oEAAoE;IACpE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,oBAAoB;EACtB;AACF","sourcesContent":["@import url('../../colors.css');\n\n.card {\n  position: relative;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--bg);\n  padding: var(--space-4) var(--space-4) var(--space-3);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-2);\n  box-shadow: var(--shadow-xs);\n}\n\n.card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 3px;\n  height: 100%;\n  border-radius: var(--radius-md) 0 0 var(--radius-md);\n  background: var(--primary);\n}\n\n.card > * {\n  position: relative; /* keep content above the accent stripe */\n}\n\n/* Header */\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.title {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.timestamp {\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n  font-variant-numeric: tabular-nums;\n}\n\n/* Content */\n.section p {\n  margin: 3px 0;\n  font-size: 0.875rem;\n  color: var(--text-primary);\n}\n\n/* Device info container */\n.deviceBox {\n  background: var(--bg-tertiary);\n  border: 1px solid var(--border-light);\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n}\n\n.deviceLabel {\n  margin: 0;\n  font-size: 0.8125rem;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.deviceText {\n  margin: 2px 0 0 0;\n  font-size: 0.8125rem;\n  color: var(--text-secondary);\n}\n\n/* Status tags */\n.tagRow {\n  display: flex;\n  gap: var(--space-2);\n  margin-top: var(--space-1);\n}\n\n.tag {\n  padding: 2px 7px;\n  border-radius: var(--radius-xs);\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.tagReviewed {\n  background: var(--surface-success);\n  color: #1b5e20;\n}\n\n.tagWarning {\n  background: var(--surface-error);\n  color: #b71c1c;\n}\n\n/* Phones: metrics in two columns so each result card stays short. */\n@media (max-width: 480px) {\n  .card {\n    padding: var(--space-3) var(--space-3) var(--space-3) var(--space-4);\n    gap: var(--space-1);\n  }\n\n  .header {\n    gap: var(--space-2);\n  }\n\n  .timestamp {\n    font-size: 0.75rem;\n    text-align: right;\n  }\n\n  .section {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    column-gap: var(--space-3);\n  }\n\n  .section p {\n    margin: 1px 0;\n    font-size: 0.8125rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `EntryCard_card__-F3zR`,
	"header": `EntryCard_header__WDCB9`,
	"title": `EntryCard_title__Scoh+`,
	"timestamp": `EntryCard_timestamp__rOTLP`,
	"section": `EntryCard_section__U7I7Q`,
	"deviceBox": `EntryCard_deviceBox__P0YWl`,
	"deviceLabel": `EntryCard_deviceLabel__5DlsK`,
	"deviceText": `EntryCard_deviceText__S6w4p`,
	"tagRow": `EntryCard_tagRow__Fi9dO`,
	"tag": `EntryCard_tag__h2JL4`,
	"tagReviewed": `EntryCard_tagReviewed__nIntS`,
	"tagWarning": `EntryCard_tagWarning__oUDpo`
};
export default ___CSS_LOADER_EXPORT___;
